(() => {
  const init = (root = document) => {
    const menuButton = root.querySelector('[data-atelier-menu]');
    if (menuButton && !menuButton.dataset.ready) {
      menuButton.dataset.ready = 'true';
      const menu = document.getElementById(menuButton.getAttribute('aria-controls'));
      menuButton.addEventListener('click', () => {
        const expanded = menuButton.getAttribute('aria-expanded') === 'true';
        menuButton.setAttribute('aria-expanded', String(!expanded));
        menu.hidden = expanded;
      });
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') { menu.hidden = true; menuButton.setAttribute('aria-expanded', 'false'); menuButton.focus(); }
      });
    }
    const searchButton = root.querySelector('[data-atelier-search]');
    if (searchButton && !searchButton.dataset.ready) {
      searchButton.dataset.ready = 'true';
      const dialog = document.getElementById(searchButton.getAttribute('aria-controls'));
      searchButton.addEventListener('click', () => dialog.showModal());
      dialog.querySelector('[data-atelier-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => searchButton.focus());
    }
    const catalog = root.querySelector('[data-atelier-catalog]');
    if (catalog && !catalog.dataset.ready) {
      catalog.dataset.ready = 'true';
      const form = catalog.querySelector('[data-atelier-filters]');
      const grid = catalog.querySelector('[data-atelier-grid]');
      const cards = Array.from(grid.children);
      const params = new URLSearchParams(location.search);
      const requested = params.get('category') || 'all';
      form.elements.category.value = ['all','sofas','chairs','tables','beds'].includes(requested) ? requested : 'all';
      form.elements.q.value = params.get('q') || '';
      const filter = () => {
        const category = form.elements.category.value;
        const query = form.elements.q.value.trim().toLocaleLowerCase('de');
        const ordered = form.elements.sort.value === 'az' ? [...cards].sort((a,b) => a.dataset.name.localeCompare(b.dataset.name)) : cards;
        let count = 0;
        ordered.forEach(card => {
          card.hidden = !((category === 'all' || card.dataset.category === category) && card.dataset.search.includes(query));
          if (!card.hidden) count++;
          grid.append(card);
        });
        catalog.querySelector('[data-atelier-count]').textContent = count;
        catalog.querySelector('[data-atelier-empty]').hidden = count !== 0;
        const url = new URL(location.href);
        category === 'all' ? url.searchParams.delete('category') : url.searchParams.set('category', category);
        query ? url.searchParams.set('q', form.elements.q.value.trim()) : url.searchParams.delete('q');
        history.replaceState(null, '', url);
      };
      form.addEventListener('input', filter);
      form.addEventListener('change', filter);
      form.addEventListener('submit', event => { event.preventDefault(); filter(); });
      catalog.querySelector('[data-atelier-reset]').addEventListener('click', () => { form.reset(); filter(); });
      filter();
    }
    const product = root.querySelector('[data-atelier-product]');
    if (product && !product.dataset.ready) {
      product.dataset.ready = 'true';
      const models = JSON.parse(product.querySelector('[data-atelier-models]').textContent);
      const param = new URLSearchParams(location.search).get('model');
      const modelKey = Object.prototype.hasOwnProperty.call(models, param) ? param : 'sofas';
      const model = models[modelKey];
      product.querySelectorAll('[data-model-name]').forEach(el => el.textContent = model.name);
      product.querySelector('[data-model-type]').textContent = model.type;
      product.querySelector('[data-model-image]').src = model.image;
      if (modelKey !== 'sofas') {
        product.querySelectorAll('[data-sofa-only]').forEach(el => el.hidden = true);
        product.querySelector('[data-other-product]').hidden = false;
        product.querySelector('.atelier-accordions details p').textContent = product.querySelector('[data-other-product]').textContent;
      }
      const form = product.querySelector('[data-atelier-config]');
      const status = product.querySelector('[data-save-status]');
      const selected = name => form.querySelector(`input[name="${name}"]:checked`);
      try {
        const saved = JSON.parse(localStorage.getItem('nazomy-sofa-configuration') || 'null');
        if (saved) ['color','fabric','size'].forEach(name => {
          const input = [...form.querySelectorAll(`input[name="${name}"]`)].find(el => el.value === saved[name]);
          if (input) input.checked = true;
        });
      } catch {}
      const update = () => {
        const color = selected('color');
        const fabric = selected('fabric');
        const size = selected('size');
        product.querySelector('[data-selected-color]').textContent = color.dataset.label;
        product.querySelector('[data-config-summary]').textContent = `${color.dataset.label} / ${fabric.dataset.label} / ${size.dataset.label}`;
        product.querySelector('[data-sample]').className = `atelier-sample atelier-fabric-${fabric.value} swatch-${color.value}`;
        status.textContent = '';
      };
      form.addEventListener('change', update);
      form.addEventListener('submit', event => {
        event.preventDefault();
        const values = Object.fromEntries(['color','fabric','size'].map(name => [name, selected(name).value]));
        try { localStorage.setItem('nazomy-sofa-configuration', JSON.stringify(values)); status.textContent = status.dataset.success; }
        catch { status.textContent = status.dataset.failure; }
      });
      update();
    }
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => init()) : init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
